import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { useState, useEffect } from "react";

const ImageSliderWrap = ({ blok }) => {
/*   console.log(blok.slider);
 */
  //ImageSlider

  const [arrowRightVisibility, setVisibilityArrwoRight] = useState("unset");
  const [arrowLeftVisibility, setVisibilityArrwoLeft] = useState("unset");
  const [translateXPosition, setTranslateXPosition] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);

  let calculatedLength = blok.slider.length - 2;

  function hideLeftArrow() {
    if (currentPosition < 1) {
      setVisibilityArrwoLeft("hidden");
    } else if (currentPosition >= 1) {
      setVisibilityArrwoLeft("unset");
    }
  }

  function hideRightArrow() {
    if (window.innerWidth > 1000) {
      if (currentPosition >= calculatedLength -1) {
        setVisibilityArrwoRight("hidden");
      } else if (currentPosition < calculatedLength) {
        setVisibilityArrwoRight("unset");
      }
    }

    if (window.innerWidth <= 1000) {
      if (currentPosition >= blok.slider.length - 1) {
        setVisibilityArrwoRight("hidden");
      } else if (currentPosition < blok.slider.length - 1) {
        setVisibilityArrwoRight("unset");
      }
    }
  }

  useEffect(() => {
    hideLeftArrow();
    hideRightArrow();
  }, [currentPosition]);

  function slideRight() {
    const images = document.getElementById("images");

    if (
      currentPosition >= 0 &&
      currentPosition < calculatedLength -1 &&
      window.innerWidth > 1000
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 100);
      images.style.transition = "0.5s ease-in-out";
    } else if (
      currentPosition >= 0 &&
      currentPosition < blok.slider.length - 1 &&
      window.innerWidth <= 1000
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 100);
      images.style.transition = "0.5s ease-in-out";
    }
  }

  function slideLeft() {
    const images = document.getElementById("images");

    if (currentPosition >= 1) {
      setTranslateXPosition(translateXPosition + 100);
      images.style.transition = "0.5s ease-in-out";
      setCurrentPosition(currentPosition - 1);
/*       console.log(currentPosition); */
    }
  }

  return (
    <div className="wrap">
    <div className="imageslider-wrap inner-wrap" {...storyblokEditable(blok)}>
      <h2 className="imageslider-subheadline merriweather text-xl pb-6">
        {blok.subheadline}
      </h2>
      <div className="imageslider-wrap-inner">
        <div
          style={{ visibility: `${arrowLeftVisibility}` }}
          className="arrow-box"
        >
          <img
            onClick={slideLeft}
            className="arrow-left"
            src="/src/arrow-left-grey-89-48.png"
            alt=""
          />
        </div>
        <div className="imageslider-content-outer">
          <div
            style={{ transform: `translateX(${translateXPosition}%)` }}
            className="imageslider-wrap-slider flex"
            id="images"
          >
            {blok.slider.map((nestedBlok) => (
              <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
            ))}
          </div>
        </div>

        <div
          style={{ visibility: `${arrowRightVisibility}` }}
          className="arrow-box"
        >
          <img
            onClick={slideRight}
            className="arrow-right"
            src="/src/arrow-right-grey-25-48.png"
            alt=""
          />
        </div>
      </div>
      <h2 className="imagesliderwrap-borderbottom merriweather text-xl pb-6"></h2>
    </div>
    </div>
  );
};
export default ImageSliderWrap;
